<template>
    <div id="app">
        <site-header v-if="! isDisclaimer"></site-header>
        <router-view></router-view>
        <site-footer v-if="! isDisclaimer"></site-footer>
    </div>
</template>
<script>
    import SiteHeader from './partials/SiteHeader'
    import SiteFooter from './partials/SiteFooter'
    import axios from 'axios'

    export default {
        components: {
            SiteHeader,
            SiteFooter
        },
        mounted() {
            if( this.$route.name === 'disclaimer' ) return;

            // navigator.geolocation.getCurrentPosition( ( position ) => {
            //     axios.get( `https://secure.geonames.org/countryCodeJSON?lat=${position.coords.latitude}&lng=${position.coords.longitude}&username=coolmind2`)
            //         .then( response => {
            //             if( ['BE', 'DE'].includes( response.data.countryCode ) ) {
            //                 this.$store.commit('enableSteelKeg')
            //             } else {
            //                 this.$store.commit('disableSteelKeg')
            //             }
            //         } )
            // } );
        },
        computed: {
            isDisclaimer() {
                return this.$route.name === 'disclaimer'
            }
        },
        metaInfo() {
            return {
                title: 'Il miglior vino alla spina',
                titleTemplate: 'MonVin | %s',
                meta: [
                    {name: 'author', content: 'Montelvini S.r.l'},
                    {property: 'og:locale', content: this.$t('locale')},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:site_name', content: 'MonVin'},
                    {name: 'tritter:card', content: 'summary'}
                ]
            }
        }
    }
</script>